export const uInt8ArrayToBASE64 = (data: Uint8Array): string => {
    const chunkSize = 1024;
    let binary = '';

    let idx = 0;

    while (idx < data.byteLength) {
        binary += String.fromCharCode.apply(null, data.slice(idx, idx + chunkSize));
        idx += chunkSize;
    }

    return btoa(binary);
};

export const uInt8ArrayToLog = (data: Uint8Array): string => {
    return `[${ data }] BASE64(${ uInt8ArrayToBASE64(data) })`;
};
